export default __webpack_public_path__ + "media/images/pound-9989ff2a9afd160edf31aeb43ee524a6.svg";